<template>
    <div class="entry-content">
        <h2>Who is <b><u>Kionier</u></b> and what do we do?</h2>
        <h6>The little software company with big dreams and big ideas.</h6>
        <br/>

        <h4>Experienced software engineer and technical consultant specializing in CRM and business application systems. 
            Industry expertise includes legal, accountancy, media, and ICT solutions firms.</h4>

        <h4>Whether you're seeking to enhance an existing system with new features or require a customized integration. 
            Take advantage of flexible and direct daily hiring options.</h4>
        <br/>
        <ul style="padding-left: 30px;">
            <li>C# .Net/ASP.net</li>
            <li>MVC, WebAPI</li>
            <li>HTML, CSS, Bootstrap</li>
            <li>JavaScript, VUEjs, Knockoutjs (MVVM)</li>
            <li>Database modelling, MSSQL</li>
        </ul>
        <br/>
        <h2>Below is just a few of the <b><u>projects</u></b> we are involved with</h2>
        <br/>
        <div class="row">
            <div class="col-sm-12 col-md-9 col-lg-8">
                <table style="width: 100%; table-layout: fixed;">
                    <tbody>
                        <tr>
                            <td style="vertical-align: top;">
                                <h2>
                                    <img
                                        src="/images/cropped-playstore-icon-32x32.png"
                                    />
                                    <b> Wersa</b>
                                </h2>
                                <h6>The Postcode that knows your location.</h6>
                                <p>Do you have trouble finding a house or business due to a lack of street names or maps? Do you understand GPS coordinates (-33.926689, 18.418764)? Then try our Wersa App, it was built to solve these problems. </p>
                                <p>
                                    <a
                                        href="http://wersa.co.za"
                                    >http://wersa.co.za</a>
                                </p>
                            </td>
                            <!-- <td style="vertical-align: top;">
                        <h1>
                            <img
                                src="http://kionier.com/wp-content/uploads/2017/09/logo53.png"
                                alt
                                width="54"
                                height="53"
                            /> KlientHub
                        </h1>
                        <h6>We just embarked on a new project to create Client Management System. It will be released on a free software license. If you are interested, please registrar using the panel to the left.</h6>
                        <p>Feature will include:</p>
                        <ul>
                            <li>Working on multiple clients at the same time</li>
                            <li>Integrated Document generation and storage</li>
                            <li>Web-base interface</li>
                            <li>Unified Time-sheet</li>
                        </ul>
                            </td>-->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <!-- .entry-content -->
</template>

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

<script>
export default {
    metaInfo() {
        return {
            title: "About | Kionier"
        };
    }
};
</script>